<template>
  <q-list>
    <slot />
  </q-list>
</template>
